import { Distance } from '../../../../../FrontendBundle/Resources/js/ofcs';
import MoveItemsCommand from '../command/moveItemsCommand';
import CutangleItem from '../item/cutangleItem';
import DrillItem from '../item/drillItem';
import LengthUnitField from './lengthUnitField';

/**
 * @class TopField
 */
export default class TopField extends LengthUnitField {
    type = 'top';
    supports = 'supportsPositioning';

    /**
     * Update item with field value.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        const bounds = item.getBounds();
        const bottomRight = bounds.getBottomRight();

        this.setValue(item.getParentItem().get('height') - bottomRight.y);
    }

    /**
     * Update field with item value.
     *
     * @param {ItemInterface} item
     */
    updateItem(item) {
        const value = item.getParentItem().get('height') - this.getValue();
        const bounds = item.getBounds();
        const bottomRight = bounds.getBottomRight();
        const difference = value - bottomRight.y;
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();

        this.assertItemValue(item, 'top', value);

        if (difference) {
            const command = new MoveItemsCommand(
                item,
                new Distance(0, difference),
            );

            history.addAndExecuteCommand(command);
        }
    }

    /**
     * Update item with field value and apply a difference.
     *
     * @param {ItemInterface} item
     *
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();
        const command = new MoveItemsCommand(
            item,
            new Distance(0, -difference),
        );

        this.assertItemValue(item, 'bottom', item.get('position').y - difference);

        history.addAndExecuteCommand(command);
    }

    /**
     * Do action.
     *
     * @param {ItemInterface} item
     */
    action(item) {
        if (!(item instanceof CutangleItem)) return;

        item.on('pointActive', point => this.setValue(item.parentItem.get('height') - point.y));
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        const supportFlag = this.supports;

        return selectionLength === 1
            && supportFlag
            && item
            && item[supportFlag]
            && !(item instanceof DrillItem)
            && !(item instanceof CutangleItem);
    }
}
